import { Theme } from '@material-ui/core/styles/createTheme';
import makeStyles from '@material-ui/core/styles/makeStyles';
import colors from './colors';
import { EdwardColors } from 'enums';
import { borderRadiusBox } from 'components/AppTheme';

export default makeStyles((theme: Theme) => ({
  assetDetailRow: {
    '& td': {
      fontSize: '12px',
      fontWeight: 700,
      textAlign: 'center',
      '&:first-child:not(:only-child)': { textAlign: 'left', width: '20%' },
      '&:last-child:not(:only-child)': { textAlign: 'right', width: '20%' },
    },
    '& ._assetTitle': {
      '& strong': {
        lineHeight: 2,
        fontSize: '14px',
        fontWeight: 900,
      },
    },
  },
  assetLinks: {
    '& a, & span': {
      display: 'inline-block',
      width: '33.333%',
      textAlign: 'center',
      '&:first-child': {
        textAlign: 'left',
        '@media (max-width:580px)': {
          width: '20%',
        },
        '@media (max-width:360px)': {
          width: '15% !important',
        },
      },
      '&:last-child': { textAlign: 'right' },
    },
  },
  assetDetails: {
    '& td': { width: '20%' },
  },
  assetDescription: {
    '& td': {
      textAlign: 'justify',
      [theme.breakpoints.down('xs')]: {
        padding: `${theme.spacing(2, 0)} !important`,
      },
    },
  },
  assetDetailTd: {
    padding: '0 !important',
    paddingRight: '0 !important',
    border: 'none !important',
  },
  assetDetail: {
    maxHeight: 0,
    overflow: 'hidden',
    transition: `max-height .${theme.transitions.duration.short}s`,
    backgroundColor: theme.palette.grey['100'],
    '& table': {
      borderStyle: 'solid',
      borderColor: 'transparent',
      borderWidth: '10px',
    },
    '& td': {
      fontSize: '12px',
      borderBottom: 'none',
      borderBottomStyle: 'none',
    },
      '& .highcharts-tooltip path': {
        display: 'none',
      },
      '& ._tooltip': {
        display: 'block',
        width: '100%',
        '& > span ': {
          background: '#f8f8f8',
          boxShadow: '0 0 10px 1px rgba(0,0,0,0.13)',
          borderRadius: borderRadiusBox,
          padding: theme.spacing(1),
        },
        '& table': {
          margin: '0 auto',
          fontFamily: 'Roboto, sans-serif',
          borderCollapse: 'collapse',
          '& ._dot': {
            fontSize: '40px',
            lineHeight: '23px',
          },
          '& td': {
            lineHeight: '21px',
            padding: '2px 6px',
            verticalAlign: 'middle',
            fontSize: '20px',
            fontWeight: 'bold',
            '@media (max-width: 400px)': {
              padding: '2px',
            },
          },
        },
      },
  },
  assetShown: {
    maxHeight: '10000px',
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  },
  swapDetail: {
    border: 'none !important',
    margin: '10px',
    width: '70%',
    '& tbody tr:nth-child(odd)': {
      background: theme.palette.grey['200'],
    },
  },
  swapDetailTitle: {
    width: '50%',
    paddingLeft: '50px',
  },
  category: {
    fontWeight: 'bold',
    '& td': {
      paddingTop: '5px',
      paddingBottom: '5px',
      color: '#fff',
    },
    '&.IK1 td': { backgroundColor: `${colors.IK1} !important` },
    '&.IK2 td': { backgroundColor: `${colors.IK2} !important` },
    '&.IK3 td': { backgroundColor: `${colors.IK3} !important` },
    '&.IK4 td': { backgroundColor: `${colors.IK4} !important` },
    '&.IK5 td': { backgroundColor: `${colors.IK5} !important` },
    '& .categoryTitle': {
      paddingLeft: 0,
      textAlign: 'left',
      fontSize: '22px',
      whiteSpace: 'nowrap',
      verticalAlign: 'middle',
      '@media (max-width: 1090px)': { fontSize: '18px' },
      '@media (max-width: 770px)': { fontSize: '17px' },
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
        paddingTop: '5px',
        paddingBottom: '3px',
      },
    },
    '& .categoryShare': {
      fontSize: '22px',
      '&._detailMode': { fontSize: '20px' },
      '@media (max-width: 1090px)': { fontSize: '18px' },
      '@media (max-width: 770px)': { fontSize: '17px' },
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
        paddingTop: '5px',
        paddingBottom: '3px',
      },
      '@media (max-width: 400px)': { fontSize: '12px !important' },
    },
  },
  total: {
    '& td': {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      borderTop: `1px solid ${theme.palette.grey['600']}`,
      [theme.breakpoints.down('xs')]: {
        borderTop: `1px dotted #ccc`,
        '&:nth-child(4)': {
          backgroundColor: '#fafafa',
        },
        '&:nth-child(5)': {
          backgroundColor: '#fff',
        },
      },
    },
  },
  correctSum: { color: EdwardColors.GREEN, borderColor: EdwardColors.GREEN },
  incorrectSum: { color: EdwardColors.ALERT, borderColor: EdwardColors.ALERT },

  overall: {
    width: '10%',
  },
  editShare: {
    padding: theme.spacing(2,1),
    '& div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& > span': {
        margin: theme.spacing(0, 1),
      },
    },
    '& .MuiFormControl-fullWidth': {
      width: theme.spacing(10),
      margin: theme.spacing(0, 0.5),
    },
    '& div > span': {
      marginLeft: theme.spacing(0.5),
    },
    '& button': {
      background: EdwardColors.LIGHT,
    },
  },
  shareTitle: {
    width: '160px',
  },
  shareValue: {},
  removeAsset: {
    background: EdwardColors.DARKER,
    color: '#000',
    '&:hover': {
      background: EdwardColors.MEDIUM,
    },
  },
  ter: {
    [theme.breakpoints.down('xs')]: { display: 'none' },
  },

  assetCategory: {
    width: '100%',
    borderBottom: 'solid #ccc 1px',
    '& h2': {
      paddingLeft: '2.5rem',
      position: 'relative',
    },
    '& h2 span': {
      display: 'inline-block',
      position: 'absolute',
      left: 0,
      width: '2rem',
    },
    '& > div > div': {
      padding: theme.spacing(2),
      borderTop: 'solid transparent 10px',
    },
    '& div.category_IK1': { borderTopColor: colors.IK1 },
    '& div.category_IK2': { borderTopColor: colors.IK2 },
    '& div.category_IK3': { borderTopColor: colors.IK3 },
    '& div.category_IK4': { borderTopColor: colors.IK4 },
    '& div.category_IK5': { borderTopColor: colors.IK5 },
    '& span.category_IK1': { backgroundColor: colors.IK1 },
    '& span.category_IK2': { backgroundColor: colors.IK2 },
    '& span.category_IK3': { backgroundColor: colors.IK3 },
    '& span.category_IK4': { backgroundColor: colors.IK4 },
    '& span.category_IK5': { backgroundColor: colors.IK5 },

    '& table td': {
      padding: theme.spacing(1),
    },
  },
  share: {
    paddingLeft: '2.5rem',
  },
}));
